import { Dispatch } from 'redux'
import { AppDispatch } from '../../types/store'
import { configsActions } from '../slices/configsSlice'

export const deleteBlockArrayItemCard =
    (payload: { path: string[]; arrOfItems: any[]; errorKeyName: string }) =>
    (dispatch: AppDispatch) => {
        dispatch(configsActions.deleteBlockArrayCardItem(payload))
    }

export const addBlockArrayCardToEnd = (payload: { path: string[], data: any }) =>
    (dispatch: AppDispatch) => {
        dispatch(configsActions.addCardToBlockArrayEnd(payload))
    }

export const dndBlockArray =
    (payload: { path: string[]; items: any[]; data: any }) =>
    (dispatch: AppDispatch) => {
        dispatch(configsActions.dndBlockArray(payload))
    }

export const duplicateArrayItem =
    (payload: { path: string[]; data: { index: number; item: any } }) =>
    (dispatch: AppDispatch) => {
        dispatch(configsActions.duplicateBlockArrayCard(payload))
    }

export const checkUnsavedChanges =
    (guid: string): any =>
    (dispatch: AppDispatch) => {
        // use setTimeout to not block ui (requestIdleCallback is not supported in safari)
        setTimeout(() =>
            dispatch(configsActions.checkUnsavedChanges({ guid }))
        )
    }

export const updateConfigHashMap =
    (guid: string, hashMap: Record<string, string>) => (dispatch: Dispatch) => {
        dispatch(configsActions.updateConfigHashMap({ guid, hashMap }))
    }